const user = {
  getlist: 'user/getlist',
  add: 'user/add',
  update: 'user/update-by-admin',
  remove: 'user/remove',
  get: 'user/get-by-admin',
  bodyHistory: 'userbodyhistory/getlist-by-admin',
  userbodyhistorycalculate: 'userbodyhistory/calculate-by-admin',
}
export default user
